import axios from 'axios'

const client = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/users`
})

export default {

  async login (profile) {
    const response = await client.post('/', profile)
    if (response.status !== 201) return console.error('Could not login user.')
    else return response.data
  },

  async getUserProfile (id) {
    const response = await client.get(id)
    if (response.status !== 200) return null
    else return response.data
  },

  async updateUserEmail (id, email) {
    const response = await client.patch(id, { email })
    if (response.status !== 200) return null
    else return response.data
  },

  async update (id, body) {
    const response = await client.put(id, body)
    if (response.status !== 200) return null
    else return response.data
  }

}
